import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getAgeRangePreview } from './helpers'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

const AgesSectionPreview = () => {
  const { t } = useTranslation()

  const targeting = useSelector(dv360TargetingSelector)

  const ageRangePreview = getAgeRangePreview(targeting)

  return <p>{t(ageRangePreview)}</p>
}

export default AgesSectionPreview
